export const messages = {
    defaultLocale: {
      //App.vue
      project: "",
      teams: "",
      tasks: "",
      drawings: "",
      documents: "",
      controllers: "",
      activity: "",
      switchTheme: "",
      //ProjectPage.vue
      projectSummary: "",
      //TeamsPage.vue
      overview: "",
      assignment: "",
      //DocumentsPage.vue
      totalDocuments: "",
      totalStorage: "",
      documentsByTeamAndUser: "",
      documentRepository: "",
      latestDocuments: "",
      name: "",
      type: "",
      size: "",
      date: "",
      folder: "",
      uploadedBy: "",
      uploadedDate: "",
      root: "",
      unknownFolder: "",
      unknownTeam: "",
      unknownUser: "",
      //charts
      itemBreakdown: "",
      controllerBreakdown: "",
      documentUploads: "",
      count: "",
      documentTypes: "",
      drawingBreakdown: "",
      activityByItem: "",
      activityByLocation: "",
      burnup: {
        title: "",
        tooltip: "",
        day: "",
        week: "",
        month: ""
      },
      velocityOverTime: "",
      velocityTooltip: "",
      day: "",
      week: "",
      month: "",
      activityByTeam: "",
      teamAndUserBreakdown: "",
      settings: {
        title: "Settings",
        url: "URL",
        username: "Username",
        password: "Password",
        selectProject: "Select Project",
        close: "Close",
        submit: "Submit",
        logout: "Logout"
      },
      welcomeMessage: "",
      loadDashboard: "",
      search: "",
      downloadPDF: "",
      downloadWord: "",
      downloadExcel: "",
      downloadCSV: "",
      A4: "",
      A3: "",
      Excel: "",
      summaryReport: "",
      subcategory: "",
      generateReport:"",
      downloadReport:"",
      reportGenerated: "",
      byCategory: "",
      byDrawingLocation: "",
      byDrawingAssignee: "",
      byController: "",
      grid: '',
      numeric: '',
      selectReportType: '',
      selectFileFormat: '',
      selectPageSize: '',
      id: "",
      item: "",
      assignedTo: "",
      location: "",
      createdBy: "",
      updatedDate: "",
      status: "",
      itemsGrid: "",
      noData: "",
      itemsPerPage: "",
      subItem: "",
      searchTeams: "",
      assign: "",
      tooltips: {
        selectUnassigned: "",
        selectAll: "",
        deselectAll: "",
      },
      headers: {
        subItem: "",
        assignedTo: "",
        updatedDate: "",
        status: "",
      },
      cards: {
        unassigned: "",
        userUnassigned: "",
        draft: "",
        open: "",
        closed: "",
      },
      assignedToYou: "",
      assignedToYourTeams: "",
      controlledByYourTeams: "",
      totalItems: "",
      totalOpenItems:"",
      totalOpenItemsTooltip: "",
      totalSubItems: "",
      totalSubItemsTooltip: "",
      category: "",
      drawingSets: "",
      others: "",
      teamDistribution: "",
      totalCount: "",
      total: "",
      rdriveBurndownChart: "",
      rdriveVelocityChart: "",
      teamProfile: "",
      unAssigned: "",
      createdByYou: "",
      loadingData: "",
      loadingActivity: "",
      noActivityWarning:"",
      showing: "",
      of: "",
      items: "",
      miniMap: {
        title: "",
        selectDrawing: "",
        selectLocation: ""
      }
    },
    en: {
      //App.vue
      project: "Project",
      teams: "Teams",
      tasks: "Tasks",
      drawings: "Drawings",
      documents: "Documents",
      controllers: "Controllers",
      activity: "Activity",
      switchTheme: "Switch to {theme} Theme",
      //ProjectPage.vue
      projectSummary: 'Project Summary',
      //TeamsPage.vue
      overview: 'Overview',
      assignment: 'Assignment',
      //DocumfentsPage.vue:
      totalDocuments: 'Total Documents',
      totalStorage: 'Total Storage',
      documentsByTeamAndUser: 'Documents by Team and User',
      documentRepository: 'Document Repository',
      latestDocuments: 'Latest Documents',
      name: 'Name',
      type: 'Type',
      size: 'Size',
      date: 'Date',
      folder: 'Folder',
      uploadedBy: 'Uploaded By',
      uploadedDate: 'Uploaded Date',
      root: 'Root',
      unknownFolder: 'Unknown Folder',
      unknownTeam: 'Unknown Team',
      unknownUser: 'Unknown User',
      //charts
      itemBreakdown: "Item Breakdown",
      controllerBreakdown: "Controller Breakdown",
      documentUploads: "Document Uploads Over Time",
      count: "Count",
      documentTypes: "Document Types",
      drawingBreakdown: "Drawing Breakdown",
      activityByItem: "Activity By Item",
      activityByLocation: "Activity By Location",
      burnup: {
        title: "Burnup",
        tooltip: "This chart shows the historic cumulative status over time of your project.",
        day: "Day",
        week: "Week",
        month: "Month"
      },
      velocityOverTime: "Velocity Over Time",
      velocityTooltip: "This chart shows the status change activity for your project",
      day: "Day",
      week: "Week",
      month: "Month",
      activityByTeam: "Activity By Team",
      teamAndUserBreakdown: "Team and User Breakdown",
      settings: {
        title: "Settings",
        url: "URL",
        username: "Username",
        password: "Password",
        selectProject: "Select Project",
        close: "Close",
        submit: "Submit",
        logout: "Logout"
      },
      welcomeMessage: "Welcome to {projectName}",
      loadDashboard: "Load Dashboard",
      search: 'Search',
      downloadPDF: 'Download PDF',
      downloadWord: 'Download Word',
      downloadExcel: 'Download Excel',
      downloadCSV: 'Download CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      subHeader:"Summary Report",
      summaryReport: "Summary Report",
      subcategory: "Subcategory",
      generateReport:"Generate Report",
      downloadReport:"Download Report",
      reportGenerated: "Report Generated",
      byCategory: "By Category",
      byDrawingLocation: "By Drawing Location",
      byDrawingAssignee: "By Drawing Assignee",
      byController: "By Controller",
      grid:"Grid",
      numeric:"Numeric",
      selectReportType:"Select Report Type",
      selectFileFormat:"Select File Format",
      selectPageSize:"Select Page Size",
      id: 'ID',
      item: 'Item',
      assignedTo: 'Assigned To',
      location: 'Location',
      createdBy: 'Created By',
      updatedDate: 'Updated Date',
      status: 'Status',
      itemsGrid: 'Items Grid',
      noData: 'No data available',
      itemsPerPage: 'Items per page',
      subItem: 'Sub-Item',
      searchTeams: "Search teams",
      assign: "Assign ({count})",
      tooltips: {
        selectUnassigned: "Select User Un-Assigned",
        selectAll: "Select All",
        deselectAll: "De-Select All",
      },
      headers: {
        subItem: "Sub-Item",
        assignedTo: "Assigned To",
        updatedDate: "Updated Date",
        status: "Status",
      },
      cards: {
        unassigned: "Un-Assigned",
        userUnassigned: "User Un-Assigned",
        draft: "Draft",
        open: "Open",
        closed: "Closed",
      },
      assignedToYou: "Assigned to You",
      assignedToYourTeams: "Assigned to your Team(s)",
      controlledByYourTeams: "Controlled by your Team(s)",
      totalItems: "Total Items",
      totalOpenItems:"Total Open Items",
      totalOpenItemsTooltip:"Total Open Items mode only includes items that are at an open status.",
      totalSubItems: "Total Sub Items",
      totalSubItemsTooltip: "Total Sub Items includes templates with multiple forms.",
      category: "Category",
      drawingSets: "Drawing Sets",
      others: "Others",
      teamDistribution: "Team Distribution",
      totalCount: "Total Count",
      total: "Total",
      rdriveBurndownChart: "rdrive-burnup-chart", //file name
      rdriveVelocityChart: "rdrive-velocity-chart", //file name
      teamProfile: "Team Profile",
      unAssigned: "Un-Assigned",
      createdByYou: "Created By You",
      createdByYourTeams: "Created by your Team(s)",
      loadingData: "Loading",
      loadingActivity: "Loading Activity",
      noActivityWarning: "There is no activity during the selected date range.",
      showing: "Showing",
      of: "of",
      items: "items",
      miniMap: {
        title: "Mini Map",
        selectDrawing: "Select Drawing",
        selectLocation: "Select Location"
      }
    },
    fr: {
      //App.vue
      project: "Projet",
      teams: "Équipes",
      tasks: "Tâches",
      drawings: "Dessins",
      documents: "Documents",
      controllers: "Contrôleurs",
      activity: "Activité",
      switchTheme: "Passer au thème {theme}",
      //ProjectPage.vue
      projectSummary: 'Résumé du projet',
      //TeamsPage.vue
      overview: 'Aperçu',
      assignment: 'Affectation',
      //DocumentsPage.vue
      totalDocuments: 'Documents Totaux',
      totalStorage: 'Stockage Total',
      documentsByTeamAndUser: 'Documents par Équipe et Utilisateur',
      documentRepository: 'Répertoire de Documents',
      latestDocuments: 'Derniers Documents',
      name: 'Nom',
      type: 'Type',
      size: 'Taille',
      date: 'Date',
      folder: 'Dossier',
      uploadedBy: 'Téléchargé par',
      uploadedDate: 'Date de Téléversement',
      root: 'Racine',
      unknownFolder: 'Dossier Inconnu',
      unknownTeam: 'Équipe Inconnue',
      unknownUser: 'Utilisateur Inconnu',
      //charts
      itemBreakdown: "Répartition des articles",
      controllerBreakdown: "Répartition du contrôleur",
      documentUploads: "Téléchargements de documents au fil du temps",
      count: "Nombre",
      documentTypes: "Types de documents",
      drawingBreakdown: "Répartition des dessins",
      activityByItem: "Activité par article",
      activityByLocation: "Activité par lieu",
      burnup: {
        title: "Diagramme de Burnup",
        tooltip: "Ce graphique montre l'état cumulatif historique de votre projet au fil du temps.",
        day: "Jour",
        week: "Semaine",
        month: "Mois"
      },
      velocityOverTime: "Vélocité au fil du temps",
      velocityTooltip: "Ce graphique montre l'activité de changement de statut pour votre projet",
      day: "Jour",
      week: "Semaine",
      month: "Mois",
      activityByTeam: "Activité par équipe",
      teamAndUserBreakdown: "Répartition par équipe et utilisateur",
      settings: {
        title: "Paramètres",
        url: "URL",
        username: "Nom d'utilisateur",
        password: "Mot de passe",
        selectProject: "Sélectionner le projet",
        close: "Fermer",
        submit: "Soumettre",
        logout: "Déconnexion"
      },
      welcomeMessage: "Bienvenue à {projectName}",
      loadDashboard: "Charger le tableau de bord",
      search: 'Chercher',
      downloadPDF: 'Télécharger PDF',
      downloadWord: 'Télécharger Word',
      downloadExcel: 'Télécharger Excel',
      downloadCSV: 'Télécharger CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      summaryReport: "Rapport de Synthèse",
      subcategory: "Sous-catégorie",
      reportGenerated: "Rapport généré",
      byCategory: "Par Catégorie",
      byDrawingLocation: "Par Dessin / Emplacement",
      byDrawingAssignee: "Par Dessin / Responsable",
      byController: "Par Contrôleur",
      generateReport: 'Générer le rapport',
      downloadReport: 'Télécharger le rapport',
      grid: 'Grille',
      numeric: 'Numérique',
      selectReportType: 'Sélectionner le type de rapport',
      selectFileFormat: 'Sélectionner le format de fichier',
      selectPageSize: 'Sélectionner la taille de page',
      id: 'ID',
      item: 'Article',
      assignedTo: 'Assigné à',
      location: 'Emplacement',
      createdBy: 'Créé par',
      updatedDate: 'Date de mise à jour',
      status: 'Statut',
      itemsGrid: 'Grille des Articles',
      noData: 'Aucune donnée disponible',
      itemsPerPage: 'Articles par page',
      subItem: 'Sous-Article',
      searchTeams: "Rechercher des équipes",
      assign: "Attribuer ({count})",
      tooltips: {
        selectUnassigned: "Sélectionner l'utilisateur non attribué",
        selectAll: "Tout sélectionner",
        deselectAll: "Tout désélectionner",
      },
      headers: {
        subItem: "Sous-élément",
        assignedTo: "Attribué à",
        updatedDate: "Date de mise à jour",
        status: "Statut",
      },
      cards: {
        unassigned: "Non attribué",
        userUnassigned: "Utilisateur non attribué",
        draft: "Brouillon",
        open: "Ouvert",
        closed: "Fermé",
      },
      assignedToYou: "Attribué à Vous",
      assignedToYourTeams: "Attribué à votre/vos équipe(s)",
      controlledByYourTeams: 'Contrôlé par votre équipe(s)',
      totalItems: 'Articles Totals',
      totalOpenItems: "Total des éléments ouverts",
      totalOpenItemsTooltip: "Le mode Total des éléments ouverts n'inclut que les éléments ayant un statut ouvert.",
      totalSubItems: 'Total des sous-articles',
      totalSubItemsTooltip: 'Le total des sous-articles comprend des modèles avec plusieurs formulaires.',
      category: "Catégorie",
      drawingSets: "Jeux de dessins",
      others: "Autres",
      teamDistribution: "Répartition de l'équipe",
      totalCount: "Nombre total",
      total: "Total",
      rdriveBurndownChart: "rdrive-burnup-chart",
      rdriveVelocityChart: "rdrive-velocity-chart",
      teamProfile: "Profil de l'équipe",
      unAssigned: "Non attribué",
      createdByYou: "Created By You",
      createdByYourTeams: "Created by your Team(s)",
      loadingData: "Chargement",
      loadingActivity: "Chargement des activités",
      noActivityWarning: "Aucune activité n'a été enregistrée pendant la période sélectionnée.",
      showing: "Affichage de",
      of: "sur",
      items: "éléments",
      miniMap: {
        title: "Mini Carte",
        selectDrawing: "Sélectionner le dessin",
        selectLocation: "Sélectionner l'emplacement"
      }
    },
    it: {
      //App.vue
      project: "Progetto",
      teams: "Squadre",
      tasks: "Compiti",
      drawings: "Disegni",
      documents: "Documenti",
      controllers: "Controller",
      activity: "Attività",
      switchTheme: "Passa al tema {theme}",
      //ProjectPage.vue
      projectSummary: 'Riepilogo del progetto',
      //TeamsPage.vue
      overview: 'Panoramica',
      assignment: 'Assegnazione',
      //DocumentsPage.vue
      totalDocuments: 'Documenti Totali',
      totalStorage: 'Archivio Totale',
      documentsByTeamAndUser: 'Documenti per Squadra e Utente',
      documentRepository: 'Archivio Documenti',
      latestDocuments: 'Ultimi Documenti',
      name: 'Nome',
      type: 'Tipo',
      size: 'Dimensione',
      date: 'Data',
      folder: 'Cartella',
      uploadedBy: 'Caricato da',
      uploadedDate: 'Data di Caricamento',
      root: 'Radice',
      unknownFolder: 'Cartella Sconosciuta',
      unknownTeam: 'Squadra Sconosciuta',
      unknownUser: 'Utente Sconosciuto',
      //charts
      itemBreakdown: "Ripartizione Elementi",
      controllerBreakdown: "Ripartizione Controller",
      documentUploads: "Caricamenti Documenti nel Tempo",
      count: "Conteggio",
      documentTypes: "Tipi di Documenti",
      drawingBreakdown: "Ripartizione Disegni",
      activityByItem: "Attività per Elemento",
      activityByLocation: "Attività per Località",
      burnup: {
        title: "Burnup",
        tooltip: "Questo grafico mostra lo stato cumulativo storico del tuo progetto nel tempo.",
        day: "Giorno",
        week: "Settimana",
        month: "Mese"
      },
      velocityOverTime: "Velocità nel Tempo",
      velocityTooltip: "Questo grafico mostra l'attività di cambiamento di stato per il tuo progetto",
      day: "Giorno",
      week: "Settimana",
      month: "Mese",
      activityByTeam: "Attività per Squadra",
      teamAndUserBreakdown: "Ripartizione per Squadra e Utente",
      settings: {
        title: "Impostazioni",
        url: "URL",
        username: "Nome utente",
        password: "Password",
        selectProject: "Seleziona Progetto",
        close: "Chiudi",
        submit: "Invia",
        logout: "Disconnetti",
      },
      welcomeMessage: "Benvenuto a {projectName}",
      loadDashboard: "Carica Dashboard",
      search: 'Cerca',
      downloadPDF: 'Scarica PDF',
      downloadWord: 'Scarica Word',
      downloadExcel: 'Scarica Excel',
      downloadCSV: 'Scarica CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      summaryReport: "Rapporto Riassuntivo",
      subcategory: "Sottocategoria",
      reportGenerated: "Rapporto generato",
      generateReport: 'Genera rapporto',
      downloadReport: 'Scarica rapporto',
      grid: 'Griglia',
      numeric: 'Numerico',
      selectReportType: 'Seleziona tipo di rapporto',
      selectFileFormat: 'Seleziona formato file',
      selectPageSize: 'Seleziona dimensione pagina',
      byCategory: "Per Categoria",
      byDrawingLocation: "Per Disegno / Posizione",
      byDrawingAssignee: "Per Disegno / Assegnatario",
      byController: "Per Controller",
      id: 'ID',
      item: 'Elemento',
      assignedTo: 'Assegnato a',
      location: 'Posizione',
      createdBy: 'Creato da',
      updatedDate: 'Data di Aggiornamento',
      status: 'Stato',
      itemsGrid: 'Griglia Elementi',
      noData: 'Nessun dato disponibile',
      itemsPerPage: 'Elementi per pagina',
      subItem: 'Sotto-Elemento',
      searchTeams: "Cerca squadre",
      assign: "Assegna ({count})",
      tooltips: {
        selectUnassigned: "Seleziona Utente Non Assegnato",
        selectAll: "Seleziona Tutto",
        deselectAll: "Deseleziona Tutto",
      },
      headers: {
        subItem: "Sotto-Elemento",
        assignedTo: "Assegnato a",
        updatedDate: "Data di Aggiornamento",
        status: "Stato",
      },
      cards: {
        unassigned: "Non Assegnato",
        userUnassigned: "Utente Non Assegnato",
        draft: "Bozza",
        open: "Aperto",
        closed: "Chiuso",
      },
      assignedToYou: "Assegnato a Te",
      assignedToYourTeams: "Assegnato al tuo Team",
      controlledByYourTeams: 'Controllato dal tuo Team',
      totalItems: 'Elementi Totali',
      totalOpenItems: "Totale Elementi Aperti",
      totalOpenItemsTooltip: "La modalità Totale Elementi Aperti include solo gli elementi con stato aperto.",
      totalSubItems: 'Totale Sotto-Elementi',
      totalSubItemsTooltip: 'Il totale dei sotto-elementi include modelli con più moduli.',
      category: "Categoria",
      drawingSets: "Set di disegni",
      others: "Altri",
      teamDistribution: "Distribuzione del team",
      totalCount: "Conteggio totale",
      total: "Totale",
      rdriveBurndownChart: "rdrive-burnup-chart",
      rdriveVelocityChart: "rdrive-velocity-chart",
      teamProfile: "Profilo del team",
      unAssigned: "Non assegnato",
      createdByYou: "Creato da te",
      createdByYourTeams: "Creato dal tuo team/dai tuoi team",
      loadingData: "Caricamento",
      loadingActivity: "Caricamento attività",
      noActivityWarning: "Nessuna attività registrata nell'intervallo di date selezionato.",
      showing: "Visualizzazione",
      of: "di",
      items: "elementi",
      miniMap: {
        title: "Mini Mappa",
        selectDrawing: "Seleziona Disegno",
        selectLocation: "Seleziona Posizione"
      }
    },
    "zh-Hans": {
      //App.vue
      project: "项目",
      teams: "团队",
      tasks: "任务",
      drawings: "图纸",
      documents: "文件",
      controllers: "控制權",
      activity: "操作记录",
      switchTheme: "切换到 {theme} 主题",
      //ProjectPage.vue
      projectSummary: '项目概况',
      //TeamsPage.vue
      overview: '概览',
      assignment: '分配',
      //DocumentsPage.vue
      totalDocuments: '总文件数',
      totalStorage: '总存储量',
      documentsByTeamAndUser: '按团队和用户的文件',
      documentRepository: '文件库',
      latestDocuments: '最新文件',
      name: '名称',
      type: '类型',
      size: '大小',
      date: '日期',
      folder: '文件夹',
      uploadedBy: '上传者',
      uploadedDate: '上传日期',
      root: '根目录',
      unknownFolder: '未知文件夹',
      unknownTeam: '未知团队',
      unknownUser: '未知用户',
      //charts
      itemBreakdown: "项目明細表",
      controllerBreakdown: "控制權明細表",
      documentUploads: "文件上传随时间变化",
      count: "计数",
      documentTypes: "文件类型",
      drawingBreakdown: "图纸明細表",
      activityByItem: "按项目操作记录",
      activityByLocation: "按位置操作记录",
      burnup: {
        title: "燃尽图",
        tooltip: "该图显示了项目随时间的历史累计状态。",
        day: "天",
        week: "周",
        month: "月"
      },
      velocityOverTime: "随时间变化的速度",
      velocityTooltip: "该图显示了项目的状态变化操作记录",
      day: "天",
      week: "周",
      month: "月",
      activityByTeam: "按团队操作记录",
      teamAndUserBreakdown: "按团队和用户明細表",
      settings: {
        title: "设置",
        url: "URL",
        username: "用户名",
        password: "密码",
        selectProject: "选择项目",
        close: "关闭",
        submit: "提交",
        logout: "登出"
      },
      welcomeMessage: "欢迎来到 {projectName}",
      loadDashboard: "加载仪表板",
      search: '搜索',
      downloadPDF: '下载 PDF',
      downloadWord: '下载 Word',
      downloadExcel: '下载 Excel',
      downloadCSV: '下载 CSV',
      A4: "A4纸",
      A3: "A3纸",
      Excel: "Excel表格",
      summaryReport: "总结报告",
      subcategory: "子类别",
      reportGenerated: "报告已生成",
      generateReport: '生成报告',
      downloadReport: '下载报告',
      grid: '网格',
      numeric: '数字',
      selectReportType: '选择报告类型',
      selectFileFormat: '选择文件格式',
      selectPageSize: '选择页面大小',
      byCategory: "按类别",
      byDrawingLocation: "按图纸/位置",
      byDrawingAssignee: "按图纸/负责人",
      byController: "按控制權",
      id: 'ID',
      item: '项目',
      assignedTo: '分配给',
      location: '位置',
      createdBy: '创建者',
      updatedDate: '更新日期',
      status: '状态',
      itemsGrid: '项目摘要',
      noData: '无可用数据',
      itemsPerPage: '每页项目数',
      subItem: '子项目',
      searchTeams: "搜索团队",
      assign: "分配 ({count})",
      tooltips: {
        selectUnassigned: "选择未分配用户",
        selectAll: "全选",
        deselectAll: "取消全选",
      },
      headers: {
        subItem: "子项目",
        assignedTo: "分配给",
        updatedDate: "更新日期",
        status: "状态",
      },
      cards: {
        unassigned: "未分配",
        userUnassigned: "用户未分配",
        draft: "草稿",
        open: "开启",
        closed: "关闭",
      },
      assignedToYou: "分配给你",
      assignedToYourTeams: "分配给你的团队",
      controlledByYourTeams: '由你的团队控制',
      totalItems: '总项目数',
      totalOpenItems: "未完成项目总数",
      totalOpenItemsTooltip: "未完成项目总数模式仅包含状态为开放的项目。",
      totalSubItems: '总子项目数',
      totalSubItemsTooltip: '总子项目数包括多个表格的模板。',
      category: "类别",
      drawingSets: "图纸集",
      others: "其他",
      teamDistribution: "团队分配",
      totalCount: "总数",
      total: "总计",
      rdriveBurndownChart: "rdrive-燃尽图",
      rdriveVelocityChart: "rdrive-速度图",
      teamProfile: "团队简介",
      unAssigned: "未分配",
      createdByYou: "由您创建",
      createdByYourTeams: "由您的团队创建",
      loadingData: "加载中",
      loadingActivity: "加载活动数据",
      noActivityWarning: "在所选日期范围内没有任何活动。",
      showing: "显示",
      of: "共",
      items: "项",
      miniMap: {
        title: "迷你地图",
        selectDrawing: "选择图纸",
        selectLocation: "选择位置"
      }
    },
    "zh-Hant": {
      //App.vue
      project: "項目",
      teams: "團隊",
      tasks: "任務",
      drawings: "圖紙",
      documents: "文件",
      controllers: "控制權",
      activity: "操作紀錄",
      switchTheme: "切換到 {theme} 主題",
      //ProjectPage.vue
      projectSummary: '項目概況',
      //TeamsPage.vue
      overview: '概覽',
      assignment: '分配',
      //DocumentsPage.vue
      totalDocuments: '總文件數',
      totalStorage: '總存儲量',
      documentsByTeamAndUser: '按團隊和用戶的文件',
      documentRepository: '文件庫',
      latestDocuments: '最新文件',
      name: '名稱',
      type: '類型',
      size: '大小',
      date: '日期',
      folder: '文件夾',
      uploadedBy: '上傳者',
      uploadedDate: '上傳日期',
      root: '根目錄',
      unknownFolder: '未知文件夾',
      unknownTeam: '未知團隊',
      unknownUser: '未知用戶',
      //charts
      itemBreakdown: "項目明細表",
      controllerBreakdown: "控制權明細表",
      documentUploads: "文件上傳隨時間變化",
      count: "計數",
      documentTypes: "文件類型",
      drawingBreakdown: "圖紙明細表",
      activityByItem: "按項目操作紀錄",
      activityByLocation: "按位置操作紀錄",
      burnup: {
        title: "燃盡圖",
        tooltip: "該圖顯示了項目隨時間的歷史累計狀態。",
        day: "天",
        week: "週",
        month: "月"
      },
      velocityOverTime: "隨時間變化的速度",
      velocityTooltip: "該圖顯示了項目的狀態變化操作紀錄",
      day: "天",
      week: "週",
      month: "月",
      activityByTeam: "按團隊操作紀錄",
      teamAndUserBreakdown: "按團隊和用戶明細表",
      settings: {
        title: "設置",
        url: "URL",
        username: "用戶名",
        password: "密碼",
        selectProject: "選擇項目",
        close: "關閉",
        submit: "提交",
        logout: "登出"
      },
      welcomeMessage: "歡迎來到 {projectName}",
      loadDashboard: "加載儀表板",
      search: '搜索',
      downloadPDF: '下載 PDF',
      downloadWord: '下載 Word',
      downloadExcel: '下載 Excel',
      downloadCSV: '下載 CSV',
      A4: "A4紙",
      A3: "A3紙",
      Excel: "Excel表格",
      summaryReport: "總結報告",
      subcategory: "子類別",
      reportGenerated: "報告已生成",
      byCategory: "按類別",
      byDrawingLocation: "按圖紙/位置",
      byDrawingAssignee: "按圖紙/負責人",
      byController: "按控制權",
      generateReport: '生成報告',
      downloadReport: '下載報告',
      grid: '網格',
      numeric: '數字',
      selectReportType: '選擇報告類型',
      selectFileFormat: '選擇檔案格式',
      selectPageSize: '選擇頁面大小',
      id: 'ID',
      item: '項目',
      assignedTo: '分配給',
      location: '位置',
      createdBy: '創建者',
      updatedDate: '更新日期',
      status: '狀態',
      itemsGrid: '項目摘要',
      noData: '無可用數據',
      itemsPerPage: '每頁項目數',
      subItem: '子項目',
      searchTeams: "搜索團隊",
      assign: "分配 ({count})",
      tooltips: {
        selectUnassigned: "選擇未分配用戶",
        selectAll: "全選",
        deselectAll: "取消全選",
      },
      headers: {
        subItem: "子項目",
        assignedTo: "分配給",
        updatedDate: "更新日期",
        status: "狀態",
      },
      cards: {
        unassigned: "未分配",
        userUnassigned: "用戶未分配",
        draft: "草稿",
        open: "開啟",
        closed: "關閉",
      },
      assignedToYou: "分配給你",
      assignedToYourTeams: "分配給你的團隊",
      controlledByYourTeams: '由你的團隊控制',
      totalItems: '總項目數',
      totalOpenItems: "未完成項目總數",
      totalOpenItemsTooltip: "未完成項目總數模式僅包含狀態為開放的項目。",
      totalSubItems: '總子項目數',
      totalSubItemsTooltip: '總子項目數包括多個表格的模板。',
      category: "類別",
      drawingSets: "圖紙集",
      others: "其他",
      teamDistribution: "團隊分配",
      totalCount: "總數",
      total: "總計",
      rdriveBurndownChart: "rdrive-燃盡圖",
      rdriveVelocityChart: "rdrive-速度圖",
      teamProfile: "團隊簡介",
      unAssigned: "未分配",
      createdByYou: "由您建立",
      createdByYourTeams: "由您的團隊建立",
      loadingData: "載入中",
      loadingActivity: "載入活動數據",
      noActivityWarning: "在所選日期範圍內沒有任何活動。",
      showing: "顯示",
      of: "共",
      items: "項",
      miniMap: {
        title: "迷你地圖",
        selectDrawing: "選擇圖紙",
        selectLocation: "選擇位置"
      }
    },
    nl: {
      //App.vue
      project: "Project",
      teams: "Teams",
      tasks: "Taken",
      drawings: "Tekeningen",
      documents: "Documenten",
      controllers: "Controllers",
      activity: "Activiteit",
      switchTheme: "Schakel over naar {theme} Thema",
      //ProjectPage.vue
      projectSummary: 'Projectoverzicht',
      //TeamsPage.vue
      overview: 'Overzicht',
      assignment: 'Toewijzing',
      //DocumentsPage.vue
      totalDocuments: 'Totale Documenten',
      totalStorage: 'Totale Opslag',
      documentsByTeamAndUser: 'Documenten per Team en Gebruiker',
      documentRepository: 'Documentenarchief',
      latestDocuments: 'Laatste Documenten',
      name: 'Naam',
      type: 'Type',
      size: 'Grootte',
      date: 'Datum',
      folder: 'Map',
      uploadedBy: 'Geüpload door',
      uploadedDate: 'Uploaddatum',
      root: 'Root',
      unknownFolder: 'Onbekende Map',
      unknownTeam: 'Onbekend Team',
      unknownUser: 'Onbekende Gebruiker',
      //charts
      itemBreakdown: "Item Uitsplitsing",
      controllerBreakdown: "Controller Uitsplitsing",
      documentUploads: "Document Uploads Over Tijd",
      count: "Aantal",
      documentTypes: "Documenttypes",
      drawingBreakdown: "Tekeningen Uitsplitsing",
      activityByItem: "Activiteit Per Item",
      activityByLocation: "Activiteit Per Locatie",
      burnup: {
        title: "Burnup",
        tooltip: "Deze grafiek toont de historische cumulatieve status van je project in de tijd.",
        day: "Dag",
        week: "Week",
        month: "Maand"
      },
      velocityOverTime: "Snelheid Over Tijd",
      velocityTooltip: "Deze grafiek toont de status wijzigingsactiviteit voor je project",
      day: "Dag",
      week: "Week",
      month: "Maand",
      activityByTeam: "Activiteit Per Team",
      teamAndUserBreakdown: "Team- en Gebruikersuitsplitsing",
      settings: {
        title: "Instellingen",
        url: "URL",
        username: "Gebruikersnaam",
        password: "Wachtwoord",
        selectProject: "Selecteer Project",
        close: "Sluiten",
        submit: "Indienen",
        logout: "Uitloggen"
      },
      welcomeMessage: "Welkom bij {projectName}",
      loadDashboard: "Dashboard Laden",
      search: 'Zoeken',
      downloadPDF: 'Download PDF',
      downloadWord: 'Download Word',
      downloadExcel: 'Download Excel',
      downloadCSV: 'Download CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      summaryReport: "Samenvattend Rapport",
      subcategory: "Subcategorie",
      reportGenerated: "Rapport gegenereerd",
      byCategory: "Per Categorie",
      byDrawingLocation: "Per Tekening / Locatie",
      byDrawingAssignee: "Per Tekening / Toegewezen Persoon",
      byController: "Per Controller",
      generateReport: 'Rapport genereren',
      downloadReport: 'Rapport downloaden',
      grid: 'Raster',
      numeric: 'Numeriek',
      selectReportType: 'Selecteer rapporttype',
      selectFileFormat: 'Selecteer bestandsformaat',
      selectPageSize: 'Selecteer paginagrootte',
      id: 'ID',
      item: 'Item',
      assignedTo: 'Toegewezen aan',
      location: 'Locatie',
      createdBy: 'Gemaakt door',
      updatedDate: 'Bijgewerkte Datum',
      status: 'Status',
      itemsGrid: 'Item Raster',
      noData: 'Geen gegevens beschikbaar',
      itemsPerPage: 'Items per pagina',
      subItem: 'Sub-Item',
      searchTeams: "Zoek teams",
      assign: "Toewijzen ({count})",
      tooltips: {
        selectUnassigned: "Selecteer Niet-Toegewezen Gebruiker",
        selectAll: "Alles selecteren",
        deselectAll: "Alles deselecteren",
      },
      headers: {
        subItem: "Sub-Item",
        assignedTo: "Toegewezen aan",
        updatedDate: "Bijgewerkte Datum",
        status: "Status",
      },
      cards: {
        unassigned: "Niet Toegewezen",
        userUnassigned: "Gebruiker Niet Toegewezen",
        draft: "Concept",
        open: "Open",
        closed: "Gesloten",
      },
      assignedToYou: "Toegewezen aan Jou",
      assignedToYourTeams: "Toegewezen aan jouw Team(s)",
      controlledByYourTeams: 'Gecontroleerd door jouw Team(s)',
      totalItems: 'Totale Items',
      totalSubItems: 'Totale Sub-Items',
      totalSubItemsTooltip: 'Totale Sub-Items omvat sjablonen met meerdere formulieren.',
      totalOpenItems: "Totaal openstaande items",
      totalOpenItemsTooltip: "De modus Totaal openstaande items bevat alleen items met een open status.",
      category: "Categorie",
      drawingSets: "Tekeningen Sets",
      others: "Anderen",
      teamDistribution: "Teamverdeling",
      totalCount: "Totaal aantal",
      total: "Totaal",
      rdriveBurndownChart: "rdrive-afloopgrafiek",
      rdriveVelocityChart: "rdrive-snelheidsgrafiek",
      teamProfile: "Teamprofiel",
      unAssigned: "Niet toegewezen",
      createdByYou: "Door u gemaakt",
      createdByYourTeams: "Gemaakt door uw team(s)",
      loadingData: "Laden",
      loadingActivity: "Activiteit laden",
      noActivityWarning: "Er is geen activiteit gedurende de geselecteerde periode.",
      showing: "Weergave",
      of: "van",
      items: "items",
      miniMap: {
        title: "Mini Kaart",
        selectDrawing: "Selecteer Tekening",
        selectLocation: "Selecteer Locatie"
      }
    },
    "pt-BR": {
      //App.vue
      project: "Projeto",
      teams: "Equipes",
      tasks: "Tarefas",
      drawings: "Desenhos",
      documents: "Documentos",
      controllers: "Controladores",
      activity: "Atividade",
      switchTheme: "Mudar para Tema {theme}",
      //ProjectPage.vue
      projectSummary: 'Resumo do Projeto',
      //TeamsPage.vue
      overview: 'Visão Geral',
      assignment: 'Atribuição',
      //DocumentsPage.vue:
      totalDocuments: 'Total de Documentos',
      totalStorage: 'Armazenamento Total',
      documentsByTeamAndUser: 'Documentos por Equipe e Usuário',
      documentRepository: 'Repositório de Documentos',
      latestDocuments: 'Documentos Recentes',
      name: 'Nome',
      type: 'Tipo',
      size: 'Tamanho',
      date: 'Data',
      folder: 'Pasta',
      uploadedBy: 'Enviado Por',
      uploadedDate: 'Data de Envio',
      root: 'Raiz',
      unknownFolder: 'Pasta Desconhecida',
      unknownTeam: 'Equipe Desconhecida',
      unknownUser: 'Usuário Desconhecido',
      //charts
      itemBreakdown: "Detalhamento de Itens",
      controllerBreakdown: "Detalhamento de Controladores",
      documentUploads: "Uploads de Documentos ao Longo do Tempo",
      count: "Quantidade",
      documentTypes: "Tipos de Documentos",
      drawingBreakdown: "Detalhamento de Desenhos",
      activityByItem: "Atividade por Item",
      activityByLocation: "Atividade por Localização",
      burnup: {
        title: "Burnup",
        tooltip: "Este gráfico mostra o histórico do status acumulado ao longo do tempo do seu projeto.",
        day: "Dia",
        week: "Semana",
        month: "Mês"
      },
      velocityOverTime: "Velocidade ao Longo do Tempo",
      velocityTooltip: "Este gráfico mostra a atividade de mudança de status do seu projeto",
      day: "Dia",
      week: "Semana",
      month: "Mês",
      activityByTeam: "Atividade por Equipe",
      teamAndUserBreakdown: "Detalhamento por Equipe e Usuário",
      settings: {
        title: "Configurações",
        url: "URL",
        username: "Nome de Usuário",
        password: "Senha",
        selectProject: "Selecionar Projeto",
        close: "Fechar",
        submit: "Enviar",
        logout: "Sair"
      },
      welcomeMessage: "Bem-vindo ao {projectName}",
      loadDashboard: "Carregar Dashboard",
      search: 'Pesquisar',
      downloadPDF: 'Baixar PDF',
      downloadWord: 'Baixar Word',
      downloadExcel: 'Baixar Excel',
      downloadCSV: 'Baixar CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      summaryReport: "Relatório Resumido",
      subcategory: "Subcategoria",
      reportGenerated: "Relatório gerado",
      byCategory: "Por Categoria",
      byDrawingLocation: "Por Desenho / Localização",
      byDrawingAssignee: "Por Desenho / Responsável",
      byController: "Por Controlador",
      generateReport: 'Gerar relatório',
      downloadReport: 'Baixar relatório',
      grid: 'Grade',
      numeric: 'Numérico',
      selectReportType: 'Selecionar tipo de relatório',
      selectFileFormat: 'Selecionar formato de arquivo',
      selectPageSize: 'Selecionar tamanho da página',
      id: 'ID',
      item: 'Item',
      assignedTo: 'Atribuído Para',
      location: 'Localização',
      createdBy: 'Criado Por',
      updatedDate: 'Data de Atualização',
      status: 'Status',
      itemsGrid: 'Grade de Itens',
      noData: 'Sem dados disponíveis',
      itemsPerPage: 'Itens por página',
      subItem: 'Sub-Item',
      searchTeams: "Pesquisar equipes",
      assign: "Atribuir ({count})",
      tooltips: {
        selectUnassigned: "Selecionar Usuários Não Atribuídos",
        selectAll: "Selecionar Todos",
        deselectAll: "Desmarcar Todos",
      },
      headers: {
        subItem: "Sub-Item",
        assignedTo: "Atribuído Para",
        updatedDate: "Data de Atualização",
        status: "Status",
      },
      cards: {
        unassigned: "Não Atribuído",
        userUnassigned: "Usuário Não Atribuído",
        draft: "Rascunho",
        open: "Aberto",
        closed: "Fechado",
      },
      assignedToYou: "Atribuído a Você",
      assignedToYourTeams: "Atribuído à(s) sua(s) Equipe(s)",
      controlledByYourTeams: "Controlado pela(s) sua(s) Equipe(s)",
      totalItems: "Total de Itens",
      totalOpenItems: "Total de Itens Abertos",
      totalOpenItemsTooltip: "O modo Total de Itens Abertos inclui apenas itens que estão em status aberto.",
      totalSubItems: "Total de Sub-Itens",
      totalSubItemsTooltip: "Total de Sub-Itens inclui templates com múltiplos formulários.",
      category: "Categoria",
      drawingSets: "Conjuntos de Desenhos",
      others: "Outros",
      teamDistribution: "Distribuição por Equipe",
      totalCount: "Contagem Total",
      total: "Total",
      rdriveBurndownChart: "rdrive-burnup-chart", //nome do arquivo
      rdriveVelocityChart: "rdrive-velocity-chart", //nome do arquivo
      teamProfile: "Perfil da Equipe",
      unAssigned: "Não Atribuído",
      createdByYou: "Criado por Você",
      createdByYourTeams: "Criado pela(s) sua(s) Equipe(s)",
      loadingData: "Carregando",
      loadingActivity: "Carregando Atividade",
      noActivityWarning: "Não há atividade durante o período selecionado.",
      showing: "Exibindo",
      of: "de",
      items: "itens",
      miniMap: {
        title: "Mini Mapa",
        selectDrawing: "Selecionar Desenho",
        selectLocation: "Selecionar Localização"
      }
    },
    th: {
      //App.vue
      project: "โครงการ",
      teams: "ทีม",
      tasks: "งาน",
      drawings: "แบบแปลน",
      documents: "เอกสาร",
      controllers: "ผู้ควบคุม",
      activity: "กิจกรรม",
      switchTheme: "เปลี่ยนเป็นธีม{theme}",
      //ProjectPage.vue
      projectSummary: 'สรุปโครงการ',
      //TeamsPage.vue
      overview: 'ภาพรวม',
      assignment: 'การมอบหมาย',
      //DocumentsPage.vue:
      totalDocuments: 'จำนวนเอกสารทั้งหมด',
      totalStorage: 'พื้นที่จัดเก็บทั้งหมด',
      documentsByTeamAndUser: 'เอกสารแยกตามทีมและผู้ใช้',
      documentRepository: 'คลังเอกสาร',
      latestDocuments: 'เอกสารล่าสุด',
      name: 'ชื่อ',
      type: 'ประเภท',
      size: 'ขนาด',
      date: 'วันที่',
      folder: 'โฟลเดอร์',
      uploadedBy: 'อัพโหลดโดย',
      uploadedDate: 'วันที่อัพโหลด',
      root: 'รูท',
      unknownFolder: 'โฟลเดอร์ไม่ทราบชื่อ',
      unknownTeam: 'ทีมไม่ทราบชื่อ',
      unknownUser: 'ผู้ใช้ไม่ทราบชื่อ',
      //charts
      itemBreakdown: "การแจกแจงรายการ",
      controllerBreakdown: "การแจกแจงผู้ควบคุม",
      documentUploads: "การอัพโหลดเอกสารตามเวลา",
      count: "จำนวน",
      documentTypes: "ประเภทเอกสาร",
      drawingBreakdown: "การแจกแจงแบบแปลน",
      activityByItem: "กิจกรรมตามรายการ",
      activityByLocation: "กิจกรรมตามสถานที่",
      burnup: {
        title: "เบิร์นดาวน์",
        tooltip: "แผนภูมินี้แสดงสถานะสะสมตามประวัติของโครงการของคุณ",
        day: "วัน",
        week: "สัปดาห์",
        month: "เดือน"
      },
      velocityOverTime: "ความเร็วตามเวลา",
      velocityTooltip: "แผนภูมินี้แสดงการเปลี่ยนแปลงสถานะสำหรับโครงการของคุณ",
      day: "วัน",
      week: "สัปดาห์",
      month: "เดือน",
      activityByTeam: "กิจกรรมตามทีม",
      teamAndUserBreakdown: "การแจกแจงทีมและผู้ใช้",
      settings: {
        title: "การตั้งค่า",
        url: "URL",
        username: "ชื่อผู้ใช้",
        password: "รหัสผ่าน",
        selectProject: "เลือกโครงการ",
        close: "ปิด",
        submit: "ส่ง",
        logout: "ออกจากระบบ"
      },
      welcomeMessage: "ยินดีต้อนรับสู่ {projectName}",
      loadDashboard: "โหลดแดชบอร์ด",
      search: 'ค้นหา',
      downloadPDF: 'ดาวน์โหลด PDF',
      downloadWord: 'ดาวน์โหลด Word',
      downloadExcel: 'ดาวน์โหลด Excel',
      downloadCSV: 'ดาวน์โหลด CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      subHeader: "รายงานสรุป",
      summaryReport: "รายงานสรุป",
      subcategory: "หมวดหมู่ย่อย",
      generateReport: "สร้างรายงาน",
      downloadReport: "ดาวน์โหลดรายงาน",
      reportGenerated: "สร้างรายงานแล้ว",
      byCategory: "ตามหมวดหมู่",
      byDrawingLocation: "ตามสถานที่แบบแปลน",
      byDrawingAssignee: "ตามผู้รับมอบหมายแบบแปลน",
      byController: "ตามผู้ควบคุม",
      grid: "ตาราง",
      numeric: "ตัวเลข",
      selectReportType: "เลือกประเภทรายงาน",
      selectFileFormat: "เลือกรูปแบบไฟล์",
      selectPageSize: "เลือกขนาดหน้า",
      id: 'รหัส',
      item: 'รายการ',
      assignedTo: 'มอบหมายให้',
      location: 'สถานที่',
      createdBy: 'สร้างโดย',
      updatedDate: 'วันที่อัปเดต',
      status: 'สถานะ',
      itemsGrid: 'ตารางรายการ',
      noData: 'ไม่มีข้อมูล',
      itemsPerPage: 'รายการต่อหน้า',
      subItem: 'รายการย่อย',
      searchTeams: "ค้นหาทีม",
      assign: "มอบหมาย ({count})",
      tooltips: {
        selectUnassigned: "เลือกผู้ใช้ที่ยังไม่ได้รับมอบหมาย",
        selectAll: "เลือกทั้งหมด",
        deselectAll: "ยกเลิกการเลือกทั้งหมด",
      },
      headers: {
        subItem: "รายการย่อย",
        assignedTo: "มอบหมายให้",
        updatedDate: "วันที่อัปเดต",
        status: "สถานะ",
      },
      cards: {
        unassigned: "ยังไม่ได้มอบหมาย",
        userUnassigned: "ผู้ใช้ที่ยังไม่ได้รับมอบหมาย",
        draft: "ร่าง",
        open: "เปิด",
        closed: "ปิด",
      },
      assignedToYou: "มอบหมายให้คุณ",
      assignedToYourTeams: "มอบหมายให้ทีมของคุณ",
      controlledByYourTeams: "ควบคุมโดยทีมของคุณ",
      totalItems: "รายการทั้งหมด",
      totalOpenItems: "รายการที่เปิดทั้งหมด",
      totalOpenItemsTooltip: "โหมดรายการที่เปิดทั้งหมดจะรวมเฉพาะรายการที่มีสถานะเปิดเท่านั้น",
      totalSubItems: "รายการย่อยทั้งหมด",
      totalSubItemsTooltip: "รายการย่อยทั้งหมดรวมถึงเทมเพลตที่มีแบบฟอร์มหลายแบบ",
      category: "หมวดหมู่",
      drawingSets: "ชุดแบบแปลน",
      others: "อื่นๆ",
      teamDistribution: "การกระจายของทีม",
      totalCount: "จำนวนรวม",
      total: "รวม",
      rdriveBurndownChart: "rdrive-burnup-chart", //file name
      rdriveVelocityChart: "rdrive-velocity-chart", //file name
      teamProfile: "โปรไฟล์ทีม",
      unAssigned: "ยังไม่ได้มอบหมาย",
      createdByYou: "สร้างโดยคุณ",
      createdByYourTeams: "สร้างโดยทีมของคุณ",
      loadingData: "กำลังโหลด",
      loadingActivity: "กำลังโหลดกิจกรรม",
      noActivityWarning: "ไม่มีกิจกรรมในช่วงวันที่ที่เลือก",
      showing: "แสดง",
      of: "จาก",
      items: "รายการ",
      miniMap: {
        title: "แผนที่ขนาดเล็ก",
        selectDrawing: "เลือกแบบแปลน",
        selectLocation: "เลือกสถานที่"
      }
    },
    de: {
      //App.vue
      project: "Projekt",
      teams: "Teams",
      tasks: "Aufgaben",
      drawings: "Zeichnungen",
      documents: "Dokumente",
      controllers: "Controller",
      activity: "Aktivität",
      switchTheme: "Zum {theme}-Design wechseln",
      //ProjectPage.vue
      projectSummary: 'Projektübersicht',
      //TeamsPage.vue
      overview: 'Überblick',
      assignment: 'Zuweisung',
      //DocumentsPage.vue:
      totalDocuments: 'Gesamtdokumente',
      totalStorage: 'Gesamtspeicher',
      documentsByTeamAndUser: 'Dokumente nach Team und Benutzer',
      documentRepository: 'Dokumentenablage',
      latestDocuments: 'Neueste Dokumente',
      name: 'Name',
      type: 'Typ',
      size: 'Größe',
      date: 'Datum',
      folder: 'Ordner',
      uploadedBy: 'Hochgeladen von',
      uploadedDate: 'Hochladedatum',
      root: 'Stammverzeichnis',
      unknownFolder: 'Unbekannter Ordner',
      unknownTeam: 'Unbekanntes Team',
      unknownUser: 'Unbekannter Benutzer',
      //charts
      itemBreakdown: "Elementaufschlüsselung",
      controllerBreakdown: "Controller-Aufschlüsselung",
      documentUploads: "Dokumenten-Uploads im Zeitverlauf",
      count: "Anzahl",
      documentTypes: "Dokumententypen",
      drawingBreakdown: "Zeichnungsaufschlüsselung",
      activityByItem: "Aktivität nach Element",
      activityByLocation: "Aktivität nach Standort",
      burnup: {
        title: "Burnup",
        tooltip: "Dieses Diagramm zeigt den historischen kumulativen Status Ihres Projekts im Zeitverlauf.",
        day: "Tag",
        week: "Woche",
        month: "Monat"
      },
      velocityOverTime: "Geschwindigkeit im Zeitverlauf",
      velocityTooltip: "Dieses Diagramm zeigt die Statusänderungsaktivität für Ihr Projekt",
      day: "Tag",
      week: "Woche",
      month: "Monat",
      activityByTeam: "Aktivität nach Team",
      teamAndUserBreakdown: "Team- und Benutzeraufschlüsselung",
      settings: {
        title: "Einstellungen",
        url: "URL",
        username: "Benutzername",
        password: "Passwort",
        selectProject: "Projekt auswählen",
        close: "Schließen",
        submit: "Absenden",
        logout: "Abmelden"
      },
      welcomeMessage: "Willkommen bei {projectName}",
      loadDashboard: "Dashboard laden",
      search: 'Suchen',
      downloadPDF: 'PDF herunterladen',
      downloadWord: 'Word herunterladen',
      downloadExcel: 'Excel herunterladen',
      downloadCSV: 'CSV herunterladen',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      subHeader: "Zusammenfassungsbericht",
      summaryReport: "Zusammenfassungsbericht",
      subcategory: "Unterkategorie",
      generateReport: "Bericht erstellen",
      downloadReport: "Bericht herunterladen",
      reportGenerated: "Bericht erstellt",
      byCategory: "Nach Kategorie",
      byDrawingLocation: "Nach Zeichnungsstandort",
      byDrawingAssignee: "Nach Zeichnungszuständigem",
      byController: "Nach Controller",
      grid: "Raster",
      numeric: "Numerisch",
      selectReportType: "Berichtstyp auswählen",
      selectFileFormat: "Dateiformat auswählen",
      selectPageSize: "Seitengröße auswählen",
      id: 'ID',
      item: 'Element',
      assignedTo: 'Zugewiesen an',
      location: 'Standort',
      createdBy: 'Erstellt von',
      updatedDate: 'Aktualisierungsdatum',
      status: 'Status',
      itemsGrid: 'Elementeraster',
      noData: 'Keine Daten verfügbar',
      itemsPerPage: 'Elemente pro Seite',
      subItem: 'Unterelement',
      searchTeams: "Teams suchen",
      assign: "Zuweisen ({count})",
      tooltips: {
        selectUnassigned: "Nicht zugewiesene Benutzer auswählen",
        selectAll: "Alle auswählen",
        deselectAll: "Alle abwählen",
      },
      headers: {
        subItem: "Unterelement",
        assignedTo: "Zugewiesen an",
        updatedDate: "Aktualisierungsdatum",
        status: "Status",
      },
      cards: {
        unassigned: "Nicht zugewiesen",
        userUnassigned: "Benutzer nicht zugewiesen",
        draft: "Entwurf",
        open: "Offen",
        closed: "Geschlossen",
      },
      assignedToYou: "Ihnen zugewiesen",
      assignedToYourTeams: "Ihrem Team/Ihren Teams zugewiesen",
      controlledByYourTeams: "Von Ihrem Team/Ihren Teams kontrolliert",
      totalItems: "Gesamtelemente",
      totalOpenItems: "Offene Elemente gesamt",
      totalOpenItemsTooltip: "Der Modus 'Offene Elemente gesamt' enthält nur Elemente mit offenem Status.",
      totalSubItems: "Unterelemente gesamt",
      totalSubItemsTooltip: "Unterelemente gesamt enthält Vorlagen mit mehreren Formularen.",
      category: "Kategorie",
      drawingSets: "Zeichnungssätze",
      others: "Sonstige",
      teamDistribution: "Teamverteilung",
      totalCount: "Gesamtanzahl",
      total: "Gesamt",
      rdriveBurndownChart: "rdrive-burnup-chart", //file name
      rdriveVelocityChart: "rdrive-velocity-chart", //file name
      teamProfile: "Teamprofil",
      unAssigned: "Nicht zugewiesen",
      createdByYou: "Von Ihnen erstellt",
      createdByYourTeams: "Von Ihrem Team/Ihren Teams erstellt",
      loadingData: "Wird geladen",
      loadingActivity: "Aktivität wird geladen",
      noActivityWarning: "Es gibt keine Aktivität im ausgewählten Zeitraum.",
      showing: "Anzeige",
      of: "von",
      items: "Elementen",
      miniMap: {
        title: "Mini-Karte",
        selectDrawing: "Zeichnung auswählen",
        selectLocation: "Standort auswählen"
      }
    },
    pl: {
      //App.vue
      project: "Projekt",
      teams: "Zespoły",
      tasks: "Zadania",
      drawings: "Rysunki",
      documents: "Dokumenty",
      controllers: "Kontrolerzy",
      activity: "Aktywność",
      switchTheme: "Przełącz na motyw {theme}",
      //ProjectPage.vue
      projectSummary: 'Podsumowanie projektu',
      //TeamsPage.vue
      overview: 'Przegląd',
      assignment: 'Przypisanie',
      //DocumentsPage.vue:
      totalDocuments: 'Łączna liczba dokumentów',
      totalStorage: 'Łączna przestrzeń',
      documentsByTeamAndUser: 'Dokumenty według zespołu i użytkownika',
      documentRepository: 'Repozytorium dokumentów',
      latestDocuments: 'Najnowsze dokumenty',
      name: 'Nazwa',
      type: 'Typ',
      size: 'Rozmiar',
      date: 'Data',
      folder: 'Folder',
      uploadedBy: 'Przesłane przez',
      uploadedDate: 'Data przesłania',
      root: 'Główny',
      unknownFolder: 'Nieznany folder',
      unknownTeam: 'Nieznany zespół',
      unknownUser: 'Nieznany użytkownik',
      //charts
      itemBreakdown: "Podział elementów",
      controllerBreakdown: "Podział kontrolerów",
      documentUploads: "Przesłane dokumenty w czasie",
      count: "Liczba",
      documentTypes: "Typy dokumentów",
      drawingBreakdown: "Podział rysunków",
      activityByItem: "Aktywność według elementu",
      activityByLocation: "Aktywność według lokalizacji",
      burnup: {
        title: "Wykres spalania",
        tooltip: "Ten wykres pokazuje historyczny skumulowany status projektu w czasie.",
        day: "Dzień",
        week: "Tydzień",
        month: "Miesiąc"
      },
      velocityOverTime: "Prędkość w czasie",
      velocityTooltip: "Ten wykres pokazuje zmiany statusu w twoim projekcie",
      day: "Dzień",
      week: "Tydzień",
      month: "Miesiąc",
      activityByTeam: "Aktywność według zespołu",
      teamAndUserBreakdown: "Podział zespołów i użytkowników",
      settings: {
        title: "Ustawienia",
        url: "URL",
        username: "Nazwa użytkownika",
        password: "Hasło",
        selectProject: "Wybierz projekt",
        close: "Zamknij",
        submit: "Zatwierdź",
        logout: "Wyloguj"
      },
      welcomeMessage: "Witaj w {projectName}",
      loadDashboard: "Wczytaj panel",
      search: 'Szukaj',
      downloadPDF: 'Pobierz PDF',
      downloadWord: 'Pobierz Word',
      downloadExcel: 'Pobierz Excel',
      downloadCSV: 'Pobierz CSV',
      A4: "A4",
      A3: "A3",
      Excel: "Excel",
      subHeader: "Raport podsumowujący",
      summaryReport: "Raport podsumowujący",
      subcategory: "Podkategoria",
      generateReport: "Generuj raport",
      downloadReport: "Pobierz raport",
      reportGenerated: "Raport wygenerowany",
      byCategory: "Według kategorii",
      byDrawingLocation: "Według lokalizacji rysunku",
      byDrawingAssignee: "Według przypisanego do rysunku",
      byController: "Według kontrolera",
      grid: "Siatka",
      numeric: "Numeryczny",
      selectReportType: "Wybierz typ raportu",
      selectFileFormat: "Wybierz format pliku",
      selectPageSize: "Wybierz rozmiar strony",
      id: 'ID',
      item: 'Element',
      assignedTo: 'Przypisane do',
      location: 'Lokalizacja',
      createdBy: 'Utworzone przez',
      updatedDate: 'Data aktualizacji',
      status: 'Status',
      itemsGrid: 'Siatka elementów',
      noData: 'Brak dostępnych danych',
      itemsPerPage: 'Elementów na stronę',
      subItem: 'Podelement',
      searchTeams: "Szukaj zespołów",
      assign: "Przypisz ({count})",
      tooltips: {
        selectUnassigned: "Wybierz nieprzypisanych użytkowników",
        selectAll: "Wybierz wszystko",
        deselectAll: "Odznacz wszystko",
      },
      headers: {
        subItem: "Podelement",
        assignedTo: "Przypisane do",
        updatedDate: "Data aktualizacji",
        status: "Status",
      },
      cards: {
        unassigned: "Nieprzypisane",
        userUnassigned: "Użytkownik nieprzypisany",
        draft: "Wersja robocza",
        open: "Otwarte",
        closed: "Zamknięte",
      },
      assignedToYou: "Przypisane do Ciebie",
      assignedToYourTeams: "Przypisane do Twoich zespołów",
      controlledByYourTeams: "Kontrolowane przez Twoje zespoły",
      totalItems: "Łączna liczba elementów",
      totalOpenItems: "Łączna liczba otwartych elementów",
      totalOpenItemsTooltip: "Tryb łącznej liczby otwartych elementów zawiera tylko elementy o statusie otwartym.",
      totalSubItems: "Łączna liczba podelementów",
      totalSubItemsTooltip: "Łączna liczba podelementów zawiera szablony z wieloma formularzami.",
      category: "Kategoria",
      drawingSets: "Zestawy rysunków",
      others: "Inne",
      teamDistribution: "Rozkład zespołów",
      totalCount: "Łączna liczba",
      total: "Suma",
      rdriveBurndownChart: "rdrive-burnup-chart", //file name
      rdriveVelocityChart: "rdrive-velocity-chart", //file name
      teamProfile: "Profil zespołu",
      unAssigned: "Nieprzypisane",
      createdByYou: "Utworzone przez Ciebie",
      createdByYourTeams: "Utworzone przez Twoje zespoły",
      loadingData: "Ładowanie",
      loadingActivity: "Ładowanie aktywności",
      noActivityWarning: "Brak aktywności w wybranym przedziale czasowym.",
      showing: "Wyświetlanie",
      of: "z",
      items: "elementów",
      miniMap: {
        title: "Mini Mapa",
        selectDrawing: "Wybierz rysunek",
        selectLocation: "Wybierz lokalizację"
      }
    }
  };